import WorkOrderEditor from './WorkOrderEditor'

export default WorkOrderEditor;